import "./who.css"
import photo from "../../img/about.jpg"
function Who(){
    return(
        <>
      <div className="who">
    <div className="continer">
       <h3> Who We Are</h3>
    </div>
    <div className="content">
        <div className="row">
            <div className="col-md-6">
                <div className="image">
                    <img src={photo} className="w-100 rounded" alt="" />
                </div>
            </div>
            <div className="col-md-6">
                <p>
                    Our medical center was established with the aim of providing distinguished healthcare that meets the needs of the local community through the use of the latest medical technologies and the best treatment methods. From the very beginning, we have strived to improve patients’ health by offering comprehensive and specialized medical services, with a focus on comfort and quality. Our goal is to be the first choice for anyone seeking reliable and effective healthcare, with a constant commitment to providing a safe and comfortable medical environment.
                </p>
                <p>
    We believe that healthcare is not just about treating illnesses, but about building trust and long-term relationships with our patients. By combining medical expertise with compassion, we ensure that every individual receives personalized care tailored to their unique needs. Our vision is to create a healthier community where prevention, early diagnosis, and effective treatment go hand in hand, empowering people to live better and longer lives.
</p>
            </div>
        </div>
    </div>
</div>
        </>
    )
}
export default  Who